import { render, staticRenderFns } from "./projects_carousel.vue?vue&type=template&id=e23560a6&scoped=true&"
import script from "./projects_carousel.vue?vue&type=script&lang=js&"
export * from "./projects_carousel.vue?vue&type=script&lang=js&"
import style0 from "./projects_carousel.vue?vue&type=style&index=0&id=e23560a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23560a6",
  null
  
)

export default component.exports